import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AdminPreviewBanner from './features/admin/shared/AdminPreviewBanner';
import ApplicationUpdateNotice from './components/ApplicationUpdateNotice';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { captureWatchlistM365Return } from './utils/watchlistM365Callback';

// Before sign-in renders anything, so Microsoft's one-time code leaves the
// address bar at once.
captureWatchlistM365Return();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={new QueryClient()}>
      <App />
      <AdminPreviewBanner />
      <ApplicationUpdateNotice />
  </QueryClientProvider>
);
reportWebVitals();
